import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import Logo from '../../assets/logo-white-2.png';
import {begin} from '../../utils/beforeunload';
import Introduksjon from '../../components/Introduksjon';
import Orddiktat from '../../components/Orddiktat';
import Ordkjedetesten from '../../components/Ordkjedetesten';
import Skrivehastighet from '../../components/Skrivehastighet';
import Leseproven from '../../components/Leseproven';
import Ordforstaelse from '../../components/Ordforstaelse';
import Ferdig from '../../components/Ferdig';
import ProgressBar from '../../components/ProgressBar';
import getTestInfo from '../../api/getTestInfo';
import getUserInfo from '../../api/getUserInfo';
import getUserGrade from '../../api/getUserGrade';
import setAnamneseVersion from '../../api/setAnamneseVersion';
import markKeyAsUsed from '../../api/markKeyAsUsed';
import {setTestCandidateGrade} from '../../actions/index';
import Byttelyd from 'components/Byttelyd';
import strings from '../../utils/strings';

const STEP_MAP = {
	intro: {
		id: 'intro',
		label: 'Introduksjon',
		component: Introduksjon,
		trackProgress: false,
	},
	1: {
		id: 'orddiktat',
		label: strings.orddiktat,
		component: Orddiktat,
		trackProgress: true,
	},
	2: {
		id: 'ordkjedetesten',
		label: strings.ordkjedetesten,
		component: Ordkjedetesten,
		trackProgress: true,
	},
	3: {
		id: 'tulleordtesten',
		label: strings.byttelydtesten,
		component: Byttelyd,
		trackProgress: true,
	},
	4: {
		id: 'skrivehastighet',
		label: strings.Skrivehastighet,
		component: Skrivehastighet,
		trackProgress: true,
	},
	5: {
		id: 'leseproven',
		label: strings.leseproven,
		component: Leseproven,
		trackProgress: true,
	},
	6: {
		id: 'ordforstaelse',
		label: strings.ordforstaelse,
		component: Ordforstaelse,
		trackProgress: true,
	},

	ferdig: {
		id: 'ferdig',
		label: 'Fertig',
		component: Ferdig,
		trackProgress: false,
	},
};

const SCREENING_TEST_ORDER = [
	STEP_MAP[3], // Byttelyd
	STEP_MAP[2], // Ordkjedetesten
	STEP_MAP[4], // Skrivehastighet
	STEP_MAP[6], // Ordforstaelse
	STEP_MAP[5], // Leseproven
	STEP_MAP[1], // Orddiktat
];

const FULL_STEPS_WITH_INTRO = [
	STEP_MAP.intro,
	...SCREENING_TEST_ORDER,
	STEP_MAP.ferdig,
];


const FULL_STEPS_NO_INTRO = [
	...SCREENING_TEST_ORDER,
	STEP_MAP.ferdig,
];

const testSteps = [
	Introduksjon,
	Byttelyd,
	Ordkjedetesten,
	Skrivehastighet,
	Ordforstaelse,
	Leseproven,
	Orddiktat,
	Ferdig,
];
var renderRemainingTests = [];

class ScreeningTest extends React.Component {
	constructor() {
		super();

		this.state = {
			isLoggedIn: false,
			includeAnamnese: false,
			activeSteps: [],
		};

		this.buildActiveSteps = this.buildActiveSteps.bind(this);
	}

	// eslint-disable-next-line react/sort-comp
buildActiveSteps(results) {
	const exclusiveTests =
		results && results.exclusiveTests
			? Object.values(results.exclusiveTests)
			: [];

	const grade = results ? results.grade : null;
	const excludeLeseproven = Boolean(results && results.excludeReading);

	const screeningTestOrder = excludeLeseproven
		? SCREENING_TEST_ORDER.filter((step) => step.id !== 'leseproven')
		: SCREENING_TEST_ORDER;

	if (exclusiveTests.length) {
		const exclusiveTestSet = new Set(
			exclusiveTests.map((testNumber) => Number(testNumber))
		);

		const remainingSteps = screeningTestOrder.filter((step) => {
			return exclusiveTestSet.has(
				Number(
					Object.keys(STEP_MAP).find(
						(key) => STEP_MAP[key] === step
					)
				)
			);
		});

		return [...remainingSteps, STEP_MAP.ferdig];
	}

	if (grade) {
		return [...screeningTestOrder, STEP_MAP.ferdig];
	}

	return [STEP_MAP.intro, ...screeningTestOrder, STEP_MAP.ferdig];
}

	componentDidMount() {
		getTestInfo().then((results) => {
			const activeSteps = this.buildActiveSteps(results);
			const excludeLeseproven = results.excludeReading;
			let shouldMarkKeyAsUsed = false;
			const exclusiveTests = results.exclusiveTests;
			const grade = results.grade;
			const testToContinue = Object.values(exclusiveTests);
			this.setState({activeSteps: activeSteps});
			if (testToContinue && testToContinue.length) {
				shouldMarkKeyAsUsed = true;

				for (let i = 0; i < testToContinue.length + 1; i++) {
					switch (testToContinue[i]) {
						case 3:
							renderRemainingTests[0] = testSteps[1];
							break;
						case 2:
							renderRemainingTests[1] = testSteps[2];
							break;
						case 4:
							renderRemainingTests[2] = testSteps[3];
							break;
						case 6:
							renderRemainingTests[3] = testSteps[4];
							break;
						case 5:
							renderRemainingTests[4] = testSteps[5];
							break;
						case 1:
							renderRemainingTests[5] = testSteps[6];
							break;
						default:
							break;
					}

					if (i === testToContinue.length) {
						renderRemainingTests = renderRemainingTests.filter(Boolean);
						renderRemainingTests.push(Ferdig);
					}
				}

				getUserGrade().then((results) => {
					this.props.onSetTestCandidateGrade(results);
				});
			} else if (grade) {
				shouldMarkKeyAsUsed = true;
				renderRemainingTests.push(
				Byttelyd,
				Ordkjedetesten,
				Skrivehastighet,
				Ordforstaelse,
				...(excludeLeseproven ? [] : [Leseproven]),
				Orddiktat,
				Ferdig
				);
				this.props.onSetTestCandidateGrade(grade);
			}

			setAnamneseVersion().then((response) => {
				if (response === 'True') {
					this.setState({includeAnamnese: true});
				} else {
					this.setState({includeAnamnese: false});
				}
			});

			const continueAfterMarkKey = () => {
	getUserInfo().then((response) => {
		if (response.ok) {
			this.setState({
				isLoggedIn: true,
			});
			begin();
		} else {
			window.location.href = `/`;
		}
	});
};

if (shouldMarkKeyAsUsed) {
	markKeyAsUsed()
		.then(() => {
			console.log('markKeyAsUsed executed');
			continueAfterMarkKey();
		})
		.catch((error) => {
			console.warn('markKeyAsUsed failed:', error);
			continueAfterMarkKey();
		});
} else {
	continueAfterMarkKey();
}
		});
	}

	render() {
		
		const {isLoggedIn, includeAnamnese, activeSteps} = this.state;
		const {currentStepIndex} = this.props;

		if (!isLoggedIn || !activeSteps.length) {
			return null;
		}

		const safeStepIndex =
			currentStepIndex >= 0 && currentStepIndex < activeSteps.length
				? currentStepIndex
				: 0;

		const currentStep = activeSteps[safeStepIndex];

		if (!currentStep) {
			return null;
		}

		const CurrentStep = currentStep.component;

		const progressSteps = activeSteps.filter((step) => step.trackProgress);
		const completedCount = activeSteps
			.slice(0, safeStepIndex + 1)
			.filter((step) => step.trackProgress).length;
		const totalCount = progressSteps.length;


				return (
	<div className="screening-test">
		<header className="lit-header screening-test__header">
			<div className="screening-test__header-inner">
				<h1 className="lit-logo">
					<img
						className="lit-logo__img"
						src={Logo}
						alt="literate-logo"
					/>
				</h1>

				{currentStep.trackProgress && (
					<div className="screening-test__progress-slot">
						<ProgressBar
							completedCount={completedCount}
							totalCount={totalCount}
							currentLabel={currentStep.label}
						/>
					</div>
				)}
			</div>
		</header>

		<div className="lit-wrapper--article text-center screening-test__content">
			<CurrentStep includeLongAnamnese={includeAnamnese} />
		</div>
	</div>
);
	}
}

const mapStateToProps = (state) => {
	const {currentStepIndex} = state;

	return {
		currentStepIndex,
	};
};
const mapDispatchToProps = {
	onSetTestCandidateGrade: setTestCandidateGrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningTest);
